var render, staticRenderFns
import script from "./ChartRadar.vue?vue&type=script&lang=ts&"
export * from "./ChartRadar.vue?vue&type=script&lang=ts&"
import style0 from "./ChartRadar.vue?vue&type=style&index=0&id=e2965404&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2965404",
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
